<script lang="ts">
    import { getContext } from "svelte";
    import type { UserProcessNavigator } from "../../modules/UserProcessNavigator";
    const nav: UserProcessNavigator = getContext("navigator");

    nav.navigateToDefaultForCurrentState();
</script>
<div>
    Thank you for confirming your information
</div>
<style>
div {
    width: 33vw;
    margin: 0 auto;
    padding: 5vh 2vw;
    text-align: center;
}
</style>
